module.exports = __webpack_public_path__ + "img/txt.5b2792a6.jpg";